/**
 * Pitch of a roof angle fixture of the given size. Both legs are drawn to the
 * same length, so the sloped one stops short of the top-right corner and its
 * rise alone fixes the angle: sin(pitch) = height / width. Past height = width
 * the leg cannot rise any further, so the pitch saturates at 90 degrees rather
 * than going undefined.
 *
 * Shared by RoofAngleIcon, which draws the leg, and the ROOF_ANGLE snap
 * template, which places a snap line along it, so the two cannot drift apart.
 */
export const roofAnglePitch = (width: number, height: number) =>
  Math.asin(Math.min(height / width, 1));
